import React, { useRef } from "react";
import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

function DraggablePaper({
  dragHandle = "#draggable-dialog-title",
  dragCancel = '[class*="MuiDialogContent-root"]',
  ...props
}) {
  const nodeRef = useRef(null);

  return (
    <Draggable
      nodeRef={nodeRef}
      handle={dragHandle}
      cancel={dragCancel}
      bounds="parent"
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

export default DraggablePaper;
